<a class="tile d-block text-center p-3 border rounded bg-white h-100"
   [routerLink]="['/categoria', c?.slug]">
  <img [src]="c?.iconUrl" alt="" class="tile__img mb-2">
  <div class="fw-semibold text-dark tile__label">{{ c?.name }}</div>
</a>
